export default __webpack_public_path__ + "edit-pencil-icon.svg";